// auth.js
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const AUTH_FB = 'AUTH_FB'
export const AUTH_REFRESH = 'AUTH_REFRESH'
export const AUTH_TIMESTAMP = 'AUTH_TIMESTAMP'
export const AUTH_IG_BUSINESS = 'AUTH_IG_BUSINESS'
export const AUTH_ADS_ACCOUNT = 'AUTH_ADS_ACCOUNT'
export const AUTH_IS_SUBSCRIBED = 'AUTH_IS_SUBSCRIBED'
export const AUTH_IS_IMPERSONATE = 'AUTH_IS_IMPERSONATE'
export const AUTH_IS_MAIL_CONFIRMED = 'AUTH_IS_MAIL_CONFIRMED'

// lang.js
export const SET_LOCALE = 'SET_LOCALE'

// app.js
export const SET_ERROR = 'SET_ERROR'
export const SET_SAVING = 'SET_SAVING'
export const SET_LOADING = 'SET_LOADING'
export const SET_SIDEBAR = 'SET_SIDEBAR'
export const SET_SEARCHING = 'SET_SEARCHING'
export const SET_TAB_LOADING = 'SET_TAB_LOADING'
export const RESET_APP = 'RESET_APP'

// user.js
export const SET_GLOBAL_MESSAGE = 'SET_GLOBAL_MESSAGE'
export const UNSET_GLOBAL_MESSAGE = 'UNSET_GLOBAL_MESSAGE'
export const CHANGE_USER_NAME = 'CHANGE_USER_NAME'
export const SET_MAIN_MESSAGE = 'SET_MAIN_MESSAGE'
export const UNSET_MAIN_MESSAGE = 'UNSET_MAIN_MESSAGE'

// limits.js
export const DECREMENT_COUNT = 'DECREMENT_COUNT'
export const INCREMENT_COUNT = 'INCREMENT_COUNT'

// creative.js
export const SET_TEMPLATE = 'SET_TEMPLATE'
export const LOAD_FONTS = 'LOAD_FONTS'
export const LOAD_TEMPLATE = 'LOAD_TEMPLATE'
export const LOAD_TEMPLATE_META = 'LOAD_TEMPLATE_META'
export const LOAD_AUTOMATED_SOURCES = 'LOAD_AUTOMATED_SOURCES'
export const SET_BOARD = 'SET_BOARD'
export const SET_FEED = 'SET_FEED'
export const SET_MIXED_TYPE = 'SET_MIXED_TYPE'
export const SET_FEED_COLUMN = 'SET_FEED_COLUMN'
export const LOAD_PREVIEW_DATA = 'LOAD_PREVIEW_DATA'
export const SET_VIDEOS_COUNT = 'SET_VIDEOS_COUNT'
export const SET_ACTIVE_SLIDE = 'SET_ACTIVE_SLIDE'
export const SET_ACTIVE_LAYER = 'SET_ACTIVE_LAYER'
export const UPDATE_LAYER = 'UPDATE_LAYER'
export const UPDATE_SCALE = 'UPDATE_SCALE'
export const UPDATE_TEMPLATE = 'UPDATE_TEMPLATE'
export const UPDATE_FILTERS = 'UPDATE_FILTERS'
export const LOAD_FILE = 'LOAD_FILE'
export const CLEANUP_FILES = 'CLEANUP_FILES'
export const TOGGLE_MODAL = 'TOGGLE_MODAL'
export const TOGGLE_MODAL_STATE = 'TOGGLE_MODAL_STATE'
export const SET_MODAL_STATE = 'SET_MODAL_STATE'
export const REMOVE_SLIDE = 'REMOVE_SLIDE'
export const DUPLICATE_SLIDE = 'DUPLICATE_SLIDE'
export const SET_SLIDE_DURATION = 'SET_SLIDE_DURATION'
export const SET_SVG_FILES = 'SET_SVG_FILES'
export const ORDER_SLIDES = 'ORDER_SLIDES'

// ig_analytics.js
export const SET_IG_ID = 'SET_IG_ID'
export const SET_DATE_RANGE = 'SET_DATE_RANGE'
export const SET_USE_GLOBAL_RANGE = 'SET_USE_GLOBAL_RANGE'
export const SET_HASHTAG_IDS = 'SET_HASHTAG_IDS'
export const SET_USE_GLOBAL_HASHTAGS = 'SET_USE_GLOBAL_HASHTAGS'
export const SET_COMPETITOR_IDS = 'SET_COMPETITOR_IDS'
export const SET_EMBEDS_UUIDS = 'SET_EMBEDS_UUIDS'
export const SET_USE_GLOBAL_COMPETITORS = 'SET_USE_GLOBAL_COMPETITORS'
export const SET_USE_GLOBAL_ACCOUNT = 'SET_USE_GLOBAL_ACCOUNT'

// creative_v3.js
export const SET_PUBLISH_META = 'SET_PUBLISH_META'
